// extracted by mini-css-extract-plugin
export var arrows = "_33-6";
export var decrementer = "_33-a";
export var disabled = "_33-4";
export var error = "_33-1";
export var hiddenText = "_33-b";
export var incrementer = "_33-9";
export var input = "_33-8";
export var inputWrapper = "_33-0";
export var leadingIcon = "_33-c";
export var readonly = "_33-3";
export var regular = "_33-7";
export var small = "_33-5";
export var warning = "_33-2";